import request from '@/utils/request'

const baseUrl = '/erp/sales/report/purchase-reference'

export const pagePurchaseReferenceReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listPurchaseReferenceSupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportPurchaseReferenceReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
